import { dueCount, scopeLabel, scopedCards } from '../core/load.js';
import { state } from '../core/state.js';
import { $, $$, dayKey } from '../core/text.js';
import { IC } from '../progress/xp.js';
import { refresh } from '../ui/views.js';
import { renderExam } from './exams.js';
import { emptyState, miniCard, renderCards, wireMiniCards } from './stats.js';

/* ══════════ Dashboard ══════════ */
export function renderDashboard() {
  const cards = scopedCards();
  const by = (l) => cards.filter((c) => c.level === l).length;
  $('#count-red').textContent = by('red');
  $('#count-yellow').textContent = by('yellow');
  $('#count-green').textContent = by('green');

  const green = by('green');
  const pct = cards.length ? Math.round((green / cards.length) * 100) : 0;
  $('#progress-pct').textContent = pct + ' %';
  $('#progress-fill').style.width = pct + '%';
  $('#progress-note').textContent = `${green} von ${cards.length} Karten sind grün`;

  const due = dueCount(cards);
  const todayCount = state.log.find((l) => l.day === dayKey())?.count || 0;
  $('#mini-stats').innerHTML = `
    <div class="mini-stat"><b>${due}</b>jetzt fällig</div>
    <div class="mini-stat"><b>${cards.length - green}</b>bis alles grün</div>
    <div class="mini-stat"><b>${by('red')}</b>noch rot</div>
    <div class="mini-stat"><b>${todayCount}</b>heute gelernt</div>`;

  const course = state.courses.find((c) => c.id === state.selCourse);
  $('#dash-title').textContent = course ? course.name : 'Übersicht';
  $('#dash-sub').textContent = course
    ? `${cards.length} Karte${cards.length === 1 ? '' : 'n'} im aktuellen Bereich`
    : 'Wähle links einen Kurs oder eine Vorlesung.';
  $('#scope-note').textContent = scopeLabel();
  $('#btn-start').disabled = !cards.length;
  $('#due-note').textContent = cards.length
    ? due ? `${due} Karte${due === 1 ? ' ist' : 'n sind'} jetzt dran – die kommen zuerst.`
          : 'Nichts fällig gerade. Du lernst dann die schwächsten Karten.'
    : '';
  renderExam();
}

/* ══════════ Sammlungen ══════════ */
export const COLLECTIONS = [
  { id: 'due', icon: 'target', name: 'Jetzt dran', desc: 'Optimaler Zeitpunkt erreicht.', fn: (c) => (c.due || 0) <= Date.now() },
  { id: 'never', icon: 'plant', name: 'Noch nie gelernt', desc: 'Noch kein einziges Mal beantwortet.', fn: (c) => c.reps === 0 },
  { id: 'often', icon: 'statistics', name: 'Oft falsch', desc: 'Min. 3× geübt, über 40 % daneben.', fn: (c) => c.reps >= 3 && c.wrong / c.reps >= 0.4 },
  { id: 'fav', icon: 'star', name: 'Favoriten', desc: 'Von dir markiert.', fn: (c) => c.fav },
  { id: 'later', icon: 'bell', name: 'Später', desc: 'Von dir zurückgestellt.', fn: (c) => c.later },
  { id: 'red', icon: 'cards', name: 'Sitzt noch nicht', desc: 'Alle roten Karten.', fn: (c) => c.level === 'red' },
  { id: 'slow', icon: 'fire', name: 'Lange gebraucht', desc: 'Über 20 s Denkzeit im Schnitt.', fn: (c) => c.reps >= 2 && c.totalMs / c.reps > 20000 },
];
export function allActiveCards() {
  const okCourses = new Set(state.courses.filter((c) => !c.archived).map((c) => c.id));
  const okDecks = new Set(state.decks.filter((d) => !d.archived && okCourses.has(d.courseId)).map((d) => d.id));
  return state.cards.filter((c) => okDecks.has(c.deckId));
}
export const collectionCards = (id) => allActiveCards().filter(COLLECTIONS.find((x) => x.id === id).fn);

/* Karten-Verwaltung als Popup (der frühere „Karten"-Reiter) – hostet das
   bestehende #cards-inner, damit Suche/Filter/Bearbeiten unverändert funktionieren. */
export function cardManagerModal() {
  const inner = document.getElementById('cards-inner'); if (!inner) return;
  const ov = document.createElement('div');
  ov.className = 'cardmgr-ov';
  ov.innerHTML = '<div class="cardmgr-box"><div class="cardmgr-bar"><b>Karten verwalten</b><button class="cardmgr-close btn-ghost outline">✕ Schließen</button></div><div class="cardmgr-host"></div></div>';
  document.body.appendChild(ov);
  ov.querySelector('.cardmgr-host').appendChild(inner);
  const prevView = state.view;
  state.view = 'cards';
  renderCards();
  const close = () => {
    document.getElementById('view-cards').appendChild(inner);
    ov.remove(); state.view = prevView; refresh();
  };
  ov.querySelector('.cardmgr-close').onclick = close;
  ov.addEventListener('click', (e) => { if (e.target === ov) close(); });
  document.addEventListener('keydown', function esc(e) { if (e.key === 'Escape') { close(); document.removeEventListener('keydown', esc); } });
}
/* Sammlungen leben jetzt unten in der Statistik – Markup einmalig dorthin verschieben. */
export function mountCollectionsInStats() {
  const host = document.getElementById('collections-host'); if (!host) return;
  const grid = document.getElementById('coll-grid'), panel = document.getElementById('coll-panel');
  if (grid && grid.parentElement !== host) host.appendChild(grid);
  if (panel && panel.parentElement !== host) host.appendChild(panel);
}
export function renderCollections() {
  if (!document.getElementById('coll-grid')) return;
  $('#coll-grid').innerHTML = COLLECTIONS.map((c) => `
    <button class="coll-card" data-coll="${c.id}">
      <img class="coll-ico" src="${IC(c.icon)}" alt="">
      <div class="coll-num">${collectionCards(c.id).length}</div>
      <div class="coll-name">${c.name}</div>
      <div class="coll-desc">${c.desc}</div>
    </button>`).join('');
  $$('[data-coll]').forEach((el) => { el.onclick = () => { state.coll = el.dataset.coll; renderCollections(); $('#coll-panel').scrollIntoView({ behavior: 'smooth', block: 'nearest' }); }; });

  if (state.coll) {
    const def = COLLECTIONS.find((c) => c.id === state.coll);
    const cards = collectionCards(state.coll);
    $('#coll-panel').classList.remove('hidden');
    $('#coll-title').textContent = `${def.name} · ${cards.length}`;
    $('#btn-coll-learn').disabled = !cards.length;
    $('#coll-list').innerHTML = cards.length ? cards.map(miniCard).join('') : emptyState('Hier ist gerade nichts drin ✦');
    wireMiniCards();
  } else $('#coll-panel').classList.add('hidden');
}

